var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [
    [_c('legend', [_vm._v("Handover Dashboard")]), _vm._v(" "), _c('b-card', [_c('div', [_c('form', {
      attrs: {
        "inline": true
      },
      on: {
        "submit": function($event) {
          $event.preventDefault();
          return _vm.onSubmit.apply(null, arguments)
        }
      }
    }, [_c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('label', [_vm._v("From Date :")]), _vm._v(" "), _c('b-form-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "type": "date",
        "placeholder": "fromDate",
        "name": "fromDate",
        "id": "fromDate"
      },
      model: {
        value: (_vm.fromDate),
        callback: function($$v) {
          _vm.fromDate = $$v
        },
        expression: "fromDate"
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('fromDate')),
        expression: "errors.has('fromDate')"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Please select from date")])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('label', [_vm._v("To Date :")]), _vm._v(" "), _c('b-form-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "type": "date",
        "placeholder": "toDate",
        "name": "toDate",
        "id": "toDate"
      },
      on: {
        "change": function($event) {
          return _vm.onDateChange()
        }
      },
      model: {
        value: (_vm.toDate),
        callback: function($$v) {
          _vm.toDate = $$v
        },
        expression: "toDate"
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('toDate')),
        expression: "errors.has('toDate')"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Please select to date")])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('label', [_vm._v("Process :")]), _vm._v(" "), _c('b-form-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "date",
        "placeholder": "toDate",
        "name": "toDate",
        "id": "toDate"
      },
      on: {
        "change": function($event) {
          return _vm.onDateChange()
        }
      },
      model: {
        value: (_vm.toDate),
        callback: function($$v) {
          _vm.toDate = $$v
        },
        expression: "toDate"
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('toDate')),
        expression: "errors.has('toDate')"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Please select process date")])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('label', [_vm._v("Status :")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.status),
        expression: "status"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "form-control",
      attrs: {
        "name": "Status",
        "id": "status"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Select Status")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "All",
        "selected": ""
      }
    }, [_vm._v("All")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Pending"
      }
    }, [_vm._v("Pending")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "PartialPending"
      }
    }, [_vm._v("Partial Pending")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "BatchClose"
      }
    }, [_vm._v("Batch Close")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Overage"
      }
    }, [_vm._v("Overage")])]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('Status')),
        expression: "errors.has('Status')"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Please select status")])])]), _vm._v(" "), _c('div', {}, [_c('div', {}, [_c('div', {
      staticClass: "form-group margin-wrap"
    }, [_c('b-button', {
      attrs: {
        "type": "submit",
        "size": "sm",
        "variant": "primary"
      }
    }, [_c('i', {
      staticClass: "fa fa-dot-circle-o"
    }), _vm._v(" Search")]), _vm._v(" "), _c('b-button', {
      attrs: {
        "type": "button",
        "size": "sm",
        "variant": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.exportAgentData()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-dot-circle-o"
    }), _vm._v(" Export")]), _vm._v(" "), _c('b-button', {
      attrs: {
        "type": "reset",
        "size": "sm",
        "variant": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.resetForm()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-ban"
    }), _vm._v(" Reset")])], 1)])])])])]), _vm._v(" "), ((_vm.returnArray && _vm.returnArray.length != 0)) ? _c('div', {}, [_c('legend', [_vm._v("Handover-Details")]), _vm._v(" "), _c('b-card', [_c('div', {
      class: {
        row: true,
        tableFixHead: true
      }
    }, [_c('table', {
      staticClass: "table-bordered table-hover tbl datatables",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "text-center tableheader"
    }, [_vm._v("Batch ID")]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_vm._v("Total Shipment")]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_vm._v("SA Inscan Count")]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_vm._v("Pending Inscan")]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_vm._v("Shortage")]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_vm._v("Overage")]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_vm._v("Courier Company Name")]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader"
    }, [_vm._v("Created Date")])])]), _vm._v(" "), _c('tbody', [(_vm.returnArray.length == 0) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": "10"
      }
    }, [_vm._v("Handover agent data not found.")])]) : _vm._e(), _vm._v(" "), _vm._l((this.agentDetailss), function(data, index) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(data.batchid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.hubname))]), _vm._v(" "), _c('td', [_c('span', {
        staticStyle: {
          "color": "blue",
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            return _vm.getAgentShipmentDetails(data.batchid, data.handovermode, data.hubid)
          }
        }
      }, [_c('b', [_vm._v(_vm._s(data.total_shipments))])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.inscan))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.pendinginscan))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shortage))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.overage))]), _vm._v(" "), _c('td', [_c('span', {
        staticClass: "badge badge-success"
      }, [_vm._v(_vm._s(data.status))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.couriercompanyname))]), _vm._v(" "), (data.createddate) ? _c('td', [_vm._v("\n                  " + _vm._s(data.createddate.replace(/T/, " ")
        .replace(/\..+/, "")) + "\n                ")]) : _vm._e()])
    })], 2)])])])], 1) : _vm._e(), _vm._v(" "), ((_vm.returnArray && _vm.returnArray.length != 0) && (_vm.agentShipmentDetails && _vm.agentShipmentDetails.length != 0)) ? _c('div', [_c('legend', [_vm._v(" Shipment Details ")]), _vm._v(" "), _c('b-card', [_c('div', {
      class: {
        row: true
      }
    }, [_c('table', {
      staticClass: "table-bordered table-hover tbl datatables",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "text-center tableheader",
      attrs: {
        "th": ""
      }
    }, [_vm._v("Batch ID")]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader",
      attrs: {
        "th": ""
      }
    }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader",
      attrs: {
        "th": ""
      }
    }, [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader",
      attrs: {
        "th": ""
      }
    }, [_vm._v("Mode")]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader",
      attrs: {
        "th": ""
      }
    }, [_vm._v("Vehical Number")]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader",
      attrs: {
        "th": ""
      }
    }, [_vm._v("Handover Person Name")]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader",
      attrs: {
        "th": ""
      }
    }, [_vm._v("Shipment Status")]), _vm._v(" "), _c('th', {
      staticClass: "text-center tableheader",
      attrs: {
        "th": ""
      }
    }, [_vm._v("Date")])])]), _vm._v(" "), _c('tbody', [((_vm.agentShipmentDetails == undefined && _vm.agentShipmentDetails.length == 0)) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": "8"
      }
    }, [_vm._v("Agent shipment details not found.")])]) : _vm._e(), _vm._v(" "), _vm._l((this.agentShipmentDetails), function(data, index) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(data.batchid))]), _vm._v(" "), _c('td', [_c('span', {
        staticClass: "badge badge-success"
      }, [_vm._v(_vm._s(data.status))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shippingid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.handovermode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.vehicleno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.handoverpersonname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.process))]), _vm._v(" "), (data.createddate) ? _c('td', [_vm._v("\n                  " + _vm._s(data.createddate.replace(/T/, " ")
        .replace(/\..+/, "")) + "\n                ")]) : _vm._e()])
    })], 2)])])])], 1) : _vm._e()]
  ], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7329c603","hasScoped":true}!./src/views/components/handoverDashboard/handoverDashboard.component.html
// module id = 829
// module chunks = 1